
import React, {} from 'react';
import _ from 'lodash'

function LocationAddress(props) {
    const { location } = props;
    const locationAdditionalFieldsTwia = location?.locationAdditionalFields_TWIA;
    const {address} = location
    let nonPhysicalLine = '';

        if (!_.isNil(locationAdditionalFieldsTwia && locationAdditionalFieldsTwia
            .locationLot_TWIA)) {
            nonPhysicalLine += `Lot ${locationAdditionalFieldsTwia.locationLot_TWIA}, `;
        }

        if (!_.isNil(locationAdditionalFieldsTwia && locationAdditionalFieldsTwia
            .locationBlock_TWIA)) {
            nonPhysicalLine += `Block ${locationAdditionalFieldsTwia.locationBlock_TWIA}, `;
        }

        if (!_.isNil(locationAdditionalFieldsTwia && locationAdditionalFieldsTwia
            .locationSection_TWIA)) {
            nonPhysicalLine += `Section ${locationAdditionalFieldsTwia.locationSection_TWIA}, `;
        }
        
        // Remove the comma from the end         
        nonPhysicalLine = nonPhysicalLine.slice(0, -2);

    return (
        <div>
            <div>
                <span><b>{!_.isNil(nonPhysicalLine) ? nonPhysicalLine : null}</b></span>
            </div>
            <div><b>{address.addressLine1}</b></div>
            <div><b>{address.city}</b></div>
            <div><b>{address.state}&nbsp;&nbsp;{address.postalCode}</b></div>
        </div>
    );
}

LocationAddress.propTypes = {

};

LocationAddress.defaultProps = {

};

export default LocationAddress;
